(function () {
  function updateLoyaltyPoints(container, priceCents) {
    const pointsEl = container.querySelector('[data-loyalty-points]');
    if (!pointsEl) return;

    const points = Math.floor(Number(priceCents) / 100);
    const label = pointsEl.dataset.pointsLabel || 'Splash Points';
    pointsEl.dataset.loyaltyPoints = String(points);
    pointsEl.textContent = `${points} ${label}`;
  }

  function labelAccordionTables(root) {
    root.querySelectorAll('.accordion__content table').forEach((table) => {
      const headerCells = table.querySelectorAll('tr:first-child th, tr:first-child td');
      if (!headerCells.length) return;

      const labels = Array.from(headerCells).map((cell) => cell.textContent.replace(/\s+/g, ' ').trim());

      table.querySelectorAll('tr').forEach((row, rowIndex) => {
        if (rowIndex === 0) return;
        row.querySelectorAll('th, td').forEach((cell, cellIndex) => {
          const label = labels[cellIndex];
          if (label) {
            cell.setAttribute('data-label', label);
          } else {
            cell.removeAttribute('data-label');
          }
        });
      });
    });
  }

  function initProductInfo(root) {
    labelAccordionTables(root);

    const upsellInput = root.querySelector('.smarte-product-info__upsell-input');
    if (upsellInput) {
      upsellInput.addEventListener('change', () => {
        upsellInput.closest('.smarte-product-info__upsell')?.classList.toggle(
          'smarte-product-info__upsell--checked',
          upsellInput.checked
        );
      });
    }

    if (typeof subscribe === 'function' && window.PUB_SUB_EVENTS?.variantChange) {
      subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
        if (!data?.variant?.price) return;
        updateLoyaltyPoints(root, data.variant.price);
      });
    }
  }

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.smarte-product-info').forEach(initProductInfo);
  });

  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll?.('.smarte-product-info')?.forEach(initProductInfo);
  });
})();
